module.exports = __webpack_public_path__ + "img/microplastics-6-mobile.7bd443c9.png";